export class PerfilTipo {
  nomeConsultaApiBase = "perfil-tipo";

  id: number;
  cdPerfilTipo: string;
  nmPerfilTipo: string;
}
